export const Types = {
    NAVIGATION_DRAWER_TOGGLE: 'ui/navigation_drawer_toggle',
};

export const navigationDrawerToggle = () => ({
    type: Types.NAVIGATION_DRAWER_TOGGLE,
    payload: {}
});
